<script setup>
import GuidanceComponent from "../../layouts/components/Notice.vue";
import HeadlineComponent from "./Headline.vue";
import PageTransition from "./PageTransition.vue";
import {inject} from "vue";
import {useRouter} from "vue-router";

const props = defineProps({
    title: String,
    selections: Array,
    previousIndex: Number,
    isTopReturn: { type: Boolean, required: false, default: false },
});

const REISSUE_MAIL_ADDRESS = inject("REISSUE_MAIL_ADDRESS", "");
const index = inject('index');
const router = useRouter();

const DESCRIPTION = "ゲームアカウントに登録したメールアドレスを利用してパスワードの再発行が可能です。\n\n登録された可能性があるメールアドレスから空メールを送信してください。\n\nご利用のメールアドレスがゲームアカウントに登録されている場合、新しいパスワードを再発行するための案内メールが届きます。";

const NOTICE_MESSAGE = "※メールが届かない場合は以下をご確認ください\n"
    + "・「" + REISSUE_MAIL_ADDRESS + "」のドメインからメールが届く設定になっているか\n"
    + "・迷惑メールフォルダに隔離されていないか";

const emit = defineEmits(['changeIndex', 'resetInputValue', 'sendMail']);

function getPreviousIndex() {
    if (!props.previousIndex) {
        return index - 1;
    }
    if (!isNaN(props.previousIndex)) {
        return props.previousIndex;
    }
    return props.previousIndex.value;
}

// 選択肢押下で即遷移（リンク的挙動）
function navigateToSelection(selection) {
    const nextIndex = typeof selection.index === 'object' ? selection.index.value : selection.index;
    emit('changeIndex', nextIndex, props.title, selection.text);
    router.push('/form/' + nextIndex);
}
</script>

<template>
    <div class="uk-margin-small-left uk-margin-small-right uk-flex-1">
        <div class="uk-flex uk-flex-column uk-height-1-1">
            <headline-component v-if="props.title" :title="props.title"/>
            <div class="uk-margin-bottom description-text">
                <p style="white-space: pre-wrap;">{{ DESCRIPTION }}</p>
            </div>
            <div>
                <a :href="'mailto:' + REISSUE_MAIL_ADDRESS">
                    <button class="uk-button uk-button-primary uk-border-rounded uk-margin-auto uk-width-auto"
                            @click="$emit('sendMail')">
                        空メールを送信する
                    </button>
                </a>
            </div>
            <div id="guidance-wrapper" class="uk-flex-1 uk-margin uk-flex uk-flex-column uk-overflow-auto">
                <Guidance-component class="uk-width-1-1" :message="NOTICE_MESSAGE"/>
                <div v-if="selections && selections.length > 0" class="uk-flex uk-flex-column uk-margin-top">
                    <template v-for="selection in selections">
                        <div class="uk-flex uk-width-medium uk-margin-auto uk-text-left">
                            <label class="uk-margin-bottom uk-width-1 uk-text-center"
                                   @click="navigateToSelection(selection)">
                                <span style="white-space: pre-wrap;">{{ selection.text }}</span>
                            </label>
                        </div>
                    </template>
                </div>
            </div>
            <page-transition
                @reset-input-value="(idx) => { $emit('resetInputValue', idx); }"
                :index="index"
                :previous-index="getPreviousIndex()"
                :next-index="null"
                :input-key="title"
                :is-active-button="false"
                :is-top-return="isTopReturn"
                :show-next-button="false">
            </page-transition>
        </div>
    </div>
</template>

<style scoped>
#guidance-wrapper {
    align-items: center;
}
.description-text {
    font-size: 1rem;
}
label {
    font-size: 1.1rem;
    padding: 5px 20px;
    background-color: #fff;
    border: 2px solid #257cde;
    border-radius: 50px;
    cursor: pointer;
    &:hover {
        border: 3px solid #257cde;
        padding: 4px 20px;
    }
}
</style>
